<template>
    <div>
        <!-- header -->
        <Header :user="user"></Header>
        <!-- Page Content -->
        <main class="pt-16">
            <slot></slot>
        </main>
        <!-- bottom -->
        <BottomBar :diamonds="user.gems"/>
    </div>
</template>
<script>
    import Header from './Header.vue';
    import axios from 'axios';
    import BottomBar from './BottomBar.vue';

    export default {
        components: {
            Header,
            BottomBar
        },
        data() {
            return {
                user : {}
            }
        },
        created() {
            this.fetchData();
        },
        methods: {
            fetchData() {
                let custObj = this;
                const headers = {
                    'Content-Type': 'application/json'
                };
                axios.get('/users/information', {headers})
                .then(response => {
                    this.user = response.data.user;
                }).catch(error => {
                    console.log(error);
                }); 
            }
        }
    }
</script>